import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './RefundSuccessModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class RefundSuccessModal extends Component {
    render() {
	  	return (
			<div>
		  		<Modal isOpen={this.props.isRefundSuccessOpen} toggle={this.toggle}>
		          	<ModalHeader toggle={this.props.toggleRefundSuccessModal}>{strings.title}</ModalHeader>
		          	<ModalBody>
						<p>{strings.content}</p>
						<div className="d-flex justify-content-center mt-4">
							<button 
								className="showtix-button showtix-background__primary-1"
								onClick={this.props.toggleRefundSuccessModal}
								>{strings.ok}</button>   
		          		</div>
					</ModalBody>
		        </Modal>
			</div>
	  	);
	}
}

RefundSuccessModal.propTypes = {
    isRefundSuccessOpen: PropTypes.bool,
	toggleRefundSuccessModal: PropTypes.func,
}

export default RefundSuccessModal;


// WEBPACK FOOTER //
// ./src/components/Search/RefundSuccessModal/RefundSuccessModal.js